import { rem, rgba, size } from "polished";
import CurrencyInput from "react-currency-input";
import styled, { css } from "styled-components";
import media from "styled-media-query";
import theme from "styled-theming";

import { themes } from "styles";

import { FeatherIcons } from "../../Icons";

import { IFieldToggler } from "./interfaces";

export const Container = styled.div``;

export const Toggle = {
  Box: styled.div`
    ${size("12px")}

    position: relative;

    margin-right: 8px;

    cursor: pointer;
    border-radius: 4px;
    border: 1px solid ${themes.utilities.border};

    ${media.greaterThan("large")`
      ${size("14px")}

      margin-right: 16px;
    `}

    ${media.greaterThan("huge")`
      ${size("18px")}

      border-radius: 6px;
    `}
  `,

  Icon: styled(FeatherIcons).attrs(() => ({ name: "check" }))`
    ${size("8px")}

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    color: #c6dbe4;
    stroke-width: 3;

    ${media.greaterThan("large")`
      ${size("10px")}

      transform: translate(-44%, -44%);
    `}

    ${media.greaterThan("huge")`
      ${size("14px")}

      transform: translate(-50%, -50%);
    `}
  `,
};

export const Icons = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const Icon = styled(FeatherIcons)`
  ${size("8px")}

  cursor: help;
  color: ${themes.palletes.success};

  &:not(:last-of-type) {
    margin-right: 8px;
  }

  ${media.greaterThan("large")`
    ${size("10px")}
  `}

  ${media.greaterThan("huge")`
    ${size("14px")}
  `}
`;

export const Field = styled.div`
  flex: 1;
`;

export const Label = styled.span`
  display: block;

  color: ${themes.text.low};
  font: 600 ${rem("6px")} ${themes.fonts.title};

  ${media.greaterThan("large")`
    font-size: ${rem("8px")};
  `}

  ${media.greaterThan("huge")`
    font-size: ${rem("12px")};
  `}
`;

export const Value = styled(CurrencyInput).attrs(() => ({
  prefix: "R$ ",
  decimalSeparator: ",",
  thousandSeparator: ".",
  type: "tel",
}))`
  all: unset;

  width: 100%;

  display: block;

  font: 600 ${rem("8px")} ${themes.fonts.text};
  color: ${themes.text.high};
  -webkit-text-fill-color: ${themes.text.high};

  &::placeholder {
    color: ${themes.text.lower};
    -webkit-text-fill-color: ${themes.text.lower};
  }

  ${media.greaterThan("large")`
    font-size: ${rem("10px")};
  `}

  ${media.greaterThan("huge")`
    font-size: ${rem("13px")};
  `}

  ${(props) =>
    props.readOnly &&
    css`
      cursor: not-allowed;
    `}
`;

export const Inner = styled.label<Pick<IFieldToggler, "readOnly" | "error">>`
  position: relative;
  padding: 0 16px;

  width: 100%;
  height: 45px;

  display: inline-flex;
  align-items: center;

  cursor: text;
  user-select: none;
  border-radius: 8px;
  border: 1px solid ${themes.utilities.border};
  background-color: ${theme("mode", {
    light: "#fbfeff",
    dark: "#1c1f25",
  })};

  ${media.greaterThan("large")`
    height: 55px;
  `}

  ${media.greaterThan("huge")`
    height: 70px;
    padding: 0 24px;
  `}

  ${(props) =>
    props.readOnly &&
    css`
      ${Value} {
        cursor: not-allowed;
      }
    `}

  ${(props) =>
    props.error &&
    css`
      border-radius: 8px 8px 0 0;
      border-color: ${rgba(themes.palletes.danger, 0.5)};
      background-color: ${rgba(themes.palletes.danger, 0.02)};

      ${Toggle.Box} {
        border-color: transparent;
        background-color: ${themes.palletes.danger};
      }

      ${Icon} {
        color: ${themes.palletes.danger};
      }
    `}
`;
